export default __webpack_public_path__ + "static/holiday-banner-image-mobile-3ee8253a0d85c70314b707781bcac2ca.svg";